import { ReactNode } from 'react';

export type ActionMapItemT = {
  title: string,
  component?: ReactNode
}

export type ActionMapT = {
  [key: string]: ActionMapItemT
};

export const getTitle = (actionsMap: ActionMapT, action: string): string => {
  if (Object.hasOwn(actionsMap, action)) return actionsMap[action].title;
  return actionsMap['default'].title;
}

export const getComponent = (actionsMap: ActionMapT, action: string): ReactNode => {
  if (Object.hasOwn(actionsMap, action)) return actionsMap[action].component;
  return actionsMap['default'].component;
}